import { datasourceInfo } from '@intelligence/components/ReportSourceLabel';
import databrainIcon from '@home/assets/svg/dataSource/databarin.svg';

/** 判断报告来源是否为 DataBrain 系（databrain / newzoo） */
export const isDataBrainSource = (source?: string): boolean =>
  !!source && ['databrain', 'newzoo'].includes(source.toLowerCase());

/** DataBrain 数据源展示项（与 marketReports 页面处理一致，databrain/newzoo 统一展示为 DataBrain） */
const DATABRAIN_DATASOURCE_INFO = { name: 'DataBrain', img: databrainIcon };

/**
 * 获取报告数据源的展示配置（name/img）
 * source 为 databrain/newzoo 时统一返回 DataBrain 展示项，其余数据源走 datasourceInfo 原有映射
 * @param source 报告数据源
 * @return 数据源展示配置，无法识别时返回 null
 */
export const getDatasourceDisplay = (source?: string) => {
  if (isDataBrainSource(source)) return DATABRAIN_DATASOURCE_INFO;
  return source ? datasourceInfo(source) : null;
};

/**
 * 判断报告是否为数据源报告（展示数据源而非创作者）
 * system === 'intelligence' 为数据源报告；
 * 其余 system（intelligence_insights / intelligence_ai / gameResearch 等）为内部创作者报告。
 */
export const isDatasourceReport = (system?: string): boolean =>
  system === 'intelligence';

/** 清理字段：过滤 undefined/null/'undefined'/'null' 为空字符串 */
export const sanitizeField = (value: string | undefined | null): string => {
  if (!value || value === 'undefined' || value === 'null') return '';
  return value;
};
